import React from "react";
import Doctor from "../Assets/doctor-group.png";
import SolutionStep from "./SolutionStep";
import "../Styles/About.css";

function About() {
  return (
    <div className="about-section" id="about">
      <div className="about-image-content">
        <img src={Doctor} alt="Doctor Group" className="about-image1" />
      </div>

      <div className="about-text-content">
        <h3 className="about-title">
          <span>About Us</span>
        </h3>
        <p className="about-description">
          Welcome to NeuroCare Clinic, your trusted partner for accessible and
          personalized neurological care. Our expert neurologists offer online consultations
          and specialized brain and nervous system services, prioritizing your neurological well-being. Join us on
          this journey towards a healthier brain.
        </p>

        <h4 className="about-text-title">Your Solutions</h4>

        <SolutionStep
          title="Choose a Neurologist"
          description="Find your perfect neurologist and book with ease at NeuroCare Clinic. Expert neurologists prioritize your brain health, offering tailored neurological care."
        />

        <SolutionStep
          title="Make a Schedule"
          description="Choose the date and time that suits you best, and let our dedicated team of neurological professionals ensure your well-being with personalized care."
        />

        <SolutionStep
          title="Get Your Solutions"
          description="Our experienced neurologists and specialists are here to provide expert advice and personalized treatment plans, helping you achieve your best possible neurological health."
        />
      </div>
    </div>
  );
}

export default About;
